import Flex from 'components/priority/Flex/Flex'
import { CaseFormSection } from 'components/dashboard/CaseDetails'
import {
  M3AdditionalFamilySection,
  M3FamilyInfoFields,
  M3GenealogySection,
} from 'components/dashboard/CaseDetails/M3FamilySections'
import { SidebarMenuSaveSection } from 'components/editor/InsertMenu/SidebarMenuSaveSection'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

export const DeceasedInfoMenu = ({ saveCase }) => {
  // The flat name+relation additional-family input is an M3-only feature;
  // MDL orders keep the original grouped-by-type input. Derived from product
  // source, not applicationType — master orders opened from MDL carry M3
  // products while the atom stays 'MDL'.
  const isM3Order = useIsM3Order()

  return (
    <>
      <Flex full center padding="8px 8px 100px 8px" gap="8px" column>
        <CaseFormSection formSection="personalInfo" sidebar={true} />
        {isM3Order ? (
          <M3FamilyInfoFields />
        ) : (
          <CaseFormSection formSection="familyInfo" sidebar={true} />
        )}
        {isM3Order ? (
          <M3AdditionalFamilySection />
        ) : (
          <CaseFormSection formSection="additionalFamily" sidebar={true} />
        )}
        {isM3Order && <M3GenealogySection />}
      </Flex>
      <SidebarMenuSaveSection saveCase={saveCase} />
    </>
  )
}

export default DeceasedInfoMenu
